<script setup lang="ts">
type BroccoliProps = {
  isOutline: boolean
  styles: {
    top: string
    left: string
    transform: string
    position: 'absolute' | 'fixed'
  }
  color?: string
}

const props = defineProps<BroccoliProps>()

const getColor = (defaultColor: string) => {
  return props.color ? props.color : defaultColor
}
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 762.13 898.23"
    :style="styles"
    class="-z-1 h-[25vh] w-[25vh] overflow-hidden"
  >
    <g id="a" />
    <g id="b" />
    <g id="c" />
    <g id="d" />
    <g id="e" />
    <g id="f" />
    <g id="g" />
    <g id="h" />
    <g id="i" />
    <g id="j">
      <g id="k" />
      <g id="l" />
      <g id="m" />
      <g id="n" />
      <g id="o" />
      <g id="p" />
      <g id="q" />
      <g id="r" />
      <g id="s" />
      <g id="t">
        <path
          class="u"
          :fill="getColor('#108063')"
          :fill-opacity="isOutline ? 0 : 1"
          :stroke-width="isOutline ? 10 : 0"
          stroke="#FFFFFF"
          d="M551.23,871.68c-9.27-11.84-24.89-25.97-30.39-39.93-5.8-14.73-2.5-29.06-11.01-44.02-7.03-12.37-21.86-19.12-30.11-32.9-8.39-14.01-11.36-30.26-18.76-44.9-30.99-61.31-65-112.67-130.86-125.87-22.68-4.54-48.1-19.1-70.97-20.08-20.31-.87-49.75,23.76-62.75,14.13-29.78,10.55-35.47,37.38-72.72,28.31-35.28-8.59-65.82-42.42-84.52-70.74-24.78-37.54-29.86-58.83-20.81-104.11,7.94-39.73-5.04-77.26,4.92-115.48,11.38-43.69,31.15-69.81,52.92-106.81,10.66-18.11,12.13-41.87,21.97-60.28,12.89-24.13,37.8-46.93,59.92-64.16,48.4-37.71,94.2-51.52,154.21-46.15,31.52,2.82,56.51-7.33,87.54-12.44,26.02-4.29,63.53-14.74,90.5-7.68,29.22,7.65,49.32,41.34,75.84,48.88,31.55,8.97,55.08-10.08,87.92,10.22,24.91,15.4,46.82,35.4,61.72,60.96,17.82,30.57,28.91,65.75,30.66,101.25,2.07,41.86-12.8,52.95-40.26,80.92-25.49,25.96-33.86,45.96-74.82,43.04-15.7-1.12-26.74-13.11-42.61-3.92-20.29,11.75-30.38,48.32-28.25,67.8,4,36.58,25.11,73.2,38.58,106.33,13.31,32.72,20.22,69.07,31.69,102.67,10.48,30.69,17.7,51.42,39.41,75.9,14.05,15.84,37.23,31.7,42.95,53.45,10.95,41.67-67.58,58.76-96.4,81.83-16.01,12.81-55.22,51.28-65.51,23.79Z"
        />
      </g>
    </g>
  </svg>
</template>

<style scoped></style>
